import { Box, Switch } from '@mui/material'
import styled from 'styled-components'
import { WrapImg } from 'styles/GlobalStyle'
import { black, dark, thirdly, thirdly2, thirdly3, thirdly4 } from 'styles/theme'
import { styled as muiStyled } from '@mui/material/styles';
import { CenterStyle } from 'styles/GlobalCss'

const radius = 25

const bpValues = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1480,
    xxl: 1780,
    xxxl: 2000,
    xxxxl: 2200
}
const { xs, sm, md, lg, xl, xxl, xxxl, xxxxl } = bpValues

const breakpoints = [
    { name: 'xxxxl', value: `@media (min-width:${xxxxl}px)`, upSize: xxxxl / xxxl },
    { name: 'xxxl', value: `@media (min-width:${xxxl}px)`, upSize: xxxl / xxl },
    { name: 'xxl', value: `@media (min-width:${xxl}px)`, upSize: xxl / xl },
    { name: 'xl', value: `@media (min-width:${xl}px)`, upSize: xl / lg },
    { name: 'lg', value: `@media (min-width:${lg}px)`, upSize: lg / md },
    { name: 'md', value: `@media (min-width:${md}px)`, upSize: md },
    { name: 'sm', value: `@media (min-width:${sm}px)`, upSize: sm },
];

const CardStyles = muiStyled(Box)(({ button, disabled, alignCenter, color, bg, height, theme, $systemUI, cartoonHeight, cartoonWidth }) => {
    let cardW = 280

    return {
        border: `1px solid ${thirdly3}`,
        borderRadius: radius,
        cursor: !disabled && button && 'pointer',
        alignItems: alignCenter && "center",
        pointerEvents: disabled && "none",
        backgroundColor: bg || "white",
        width: cardW,
        display: "flex",
        flexDirection: "column",
        justifyContent: alignCenter ? "center" : "space-between",
        padding: 25,
        boxSizing: "border-box",
        height: height || "100%",
        fontSize: 30,
        fontWeight: 700,
        color: color || dark,
    }
});

export const GeneralDashboardStyles = muiStyled(Box)(({ theme, $systemUI }) => {
    return {
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
        height: "100%",
        alignItems: "center",
    }
});

const CartoonStyles = muiStyled(Box)(({ theme, width, height }) => {
    return {
        width: width,
        height: height,
        [theme.breakpoints.down('xxl')]: {
            width: width * 0.75,
            height: height * 0.75,
        }
    }
})

const StudentDashboardStyles = muiStyled(Box)(({ theme, $systemUI, cartoonHeight, cartoonWidth }) => {
    let cardW = 300
    let cardGap = 20
    let contentH = 500

    return {
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        height: "100%",
        width: "100%",
        rowGap: 50,
        '.dashboard-card': {
            borderRadius: radius,
            backgroundColor: "white",
            // width: cardW,
            // width: "25%",
            width: 275,
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            flexGrow: 1,
            padding: 15,
            [theme.breakpoints.down('md')]: {
                width: "auto",
            }
        },
        '.logout': {
            position: "absolute",
            top: 25,
            right: 25
        },
        '.start-a-task': {
            display: "flex",
            columnGap: 10,
            fontWeight: 300
        },
        '.left-cards': {
            display: "flex",
            flexDirection: "column",
            rowGap: cardGap,
            height: "100%"
        },
        '.dashboard-content': {
            display: "flex",
            alignItems: "center",
            flexGrow: 1,
            overflowY: "auto"
        },
        '.dashboard-cards-content': {
            alignItems: "center",
            padding: 15,
            display: "flex",
            columnGap: cardGap,
            rowGap: cardGap,
            width: "100%",
            // width: cardW * 4 + cardGap * 3,
            height: contentH,
            justifyContent: "center",
            [theme.breakpoints.down('md')]: {
                height: 300
            },
        },
        '.cartoon-img': {
            position: "relative",
            right: 75,
            top: 27,
            width: 300,
            height: 300,
            [theme.breakpoints.down('md')]: {
                height: 200,
                width: 200,
            },
        },
        '.task-img': {
            position: "relative",
            left: 75,
            width: 150,
            height: 150,
            [theme.breakpoints.down('md')]: {
                height: 100,
                width: 100,
            },
        }
    }
});

const DashboardStyles = muiStyled(Box)(({ theme, $systemUI, cartoonHeight, cartoonWidth }) => {
    return {
    }
});

const DoughnutChartStyles = muiStyled(Box)(({ type, theme, $systemUI }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%"
}));

export const BasicDashboardStyles = muiStyled(Box)(({ type, theme, $systemUI }) => ({
    width: "100%",
    fontSize: 17,
    // [theme.breakpoints.up('xxxxl')]: {
    //     fontSize: 18
    // },
    height: "100%",
    overflow: "auto",
    boxSizing: "border-box",
    alignItems: "center",
    // הריווח של הדף מוגדר רק ב-.dashboard-content  בלי padding כפול
    padding: 0,
    display: "flex",
    flexDirection: "column",
    rowGap: 15,
    '.dashboard-title': {
        height: 80,
        fontWeight: "bold",
        padding: 30,
        width: 160,
        [theme.breakpoints.down('md')]: {
            height: 40,
            width: 200,
            padding: 15
        }
    },
    '.dashboard-cartoon': {
        position: "relative",
        right: 15,
        width: 170,
        height: 280,
        [theme.breakpoints.down('md')]: {
            width: 100,
            height: 200,
        },
        [theme.breakpoints.up('xxxxl')]: {
            width: 240,
            height: 300,
            right: 45,
        },
    },
    '.card-icon': {
        height: '30%',
        ...CenterStyle,
        ".MuiSvgIcon-root": {
            fill: "transparent !important"
        }
    },
    '.doughnut-and-list': {
        display: "flex",
        flexDirection: "column",
        rowGap: 15
    },
    '.level-list': {
        display: "flex",
        justifyContent: "end",
        margin: 20,
        [theme.breakpoints.down('xxl')]: {
            margin: 2
        }
    },
    '.wrap-doughnut-chart': {
        display: "flex",
        flexDirection: "column",
        rowGap: 30,
        justifyContent: "space-between",
        height: "100%",
    },
    '.all-data-btn': {
        display: "flex",
        justifyContent: "end"
    },
    '.doughnut-chart-item': {
        width: 200,
        height: 200,
        [theme.breakpoints.up('xxxxl')]: {
            width: 300,
            height: 300,
        }
    },
    '.doughnut-chart': {
        display: "flex",
        columnGap: 10,
        justifyContent: "space-around"
    },
    '.circle-stats-list': {
        display: "flex",
        columnGap: 15
    },
    '.card-actions': {
        display: "flex",
        alignItems: "space-between",
        flexDirection: "column",
        justifyContent: "center",
        rowGap: 10,
        [theme.breakpoints.up('xxxxl')]: {
            rowGap: 15,
        },

    },
    '.card-action': {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between !important",
    },
    '.wrap-dashboard-video': {
        width: "100%",
        height: 240,
        borderRadius: 8,
        backgroundSize: "cover",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(https://i.ibb.co/CkD0sY5/Group-49380-1.png)`,
        '.MuiSvgIcon-root': {
            fill: "transparent !important",
            fontSize: 30
        },
        [theme.breakpoints.up('xxl')]: {
            height: 200,
        },
        [theme.breakpoints.up('xxxxl')]: {
            height: 350,
        },
        [theme.breakpoints.up('xxxxxl')]: {
            height: 450,
        },
    },
    '.video-duration': {
        fontWeight: 500
    },
    '.wrap-card-title': {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    '.card-title': {
        height: 30,
        display: "flex",
        columnGap: 10,
        alignItems: "center",
        fontWeight: "bold",
        lineHeight: "15px"
    },
    // משימה z8rp3f97mn -  קוביית תרגולים 
    '.details-card': {
        width: "auto",
        padding: 24,
        border: "none",
        borderRadius: 16,
    },
    '.practice-card': {
        width: 441,
        flexShrink: 0,
        boxSizing: "border-box",
        background: "white",
        border: "1px solid rgba(232, 238, 246, 0.9)",
        borderRadius: 18,
        [theme.breakpoints.down('lg')]: {
            width: "100%",
            minHeight: 300,
        },
    },
    '.welcome-cards': {
        flexGrow: 1,
        display: "flex",
        columnGap: 15,
        width: "100%",
        [theme.breakpoints.down('lg')]: {
            flexDirection: "column",
            alignItems: "center",
            rowGap: 15,
            width: "100%"
        },
    },
    '.welcome-cards1': {
        flexGrow: 1,
        display: "flex",
        columnGap: 24,
        [theme.breakpoints.down('lg')]: {
            flexDirection: "column",
            alignItems: "center",
            rowGap: 15,
            width: "100%"
        },
    },
    '.dashboard-content': {
        height: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        padding: "0 24px 24px",
        display: "flex",
        flexDirection: "column",
        rowGap: 24,
        width: "100%",
        [theme.breakpoints.up('xxxxl')]: {
            justifyContent: "center",
        },
    },
    // המצגת תופסת את רוחב שני הכרטיסים (וידאו + גרף דירוגים)
    '.presentation-full-card': {
        width: "100% !important",
    },
    '.welcome-card': {
        width: "50%",
        flexGrow: 1,
        background: "white",
        borderRadius: 'var(--XL, 16px)',
        border: '1px solid #91BDFA',
        padding: 15,
        display: "flex",
        flexDirection: "column",
        rowGap: 10,
        boxSizing: "border-box",
        justifyContent: "space-between",
        [theme.breakpoints.down('lg')]: {
            width: "100%",
        },
        [theme.breakpoints.up('xxxxl')]: {
            rowGap: 17,
            justifyContent: "start",
        },
    },
    '.cartoon-card': {
        width: 250,
        background: thirdly2,
        borderRadius: 15,
        [theme.breakpoints.down('xl')]: {
            width: "100%",
            display: "none"
        }
    },
    '.text': {
        color: "#26445A80"
    },
    '.card-content': {
        height: 35,
        justifyContent: "start",
        [theme.breakpoints.up('xl')]: {
            height: 40
        },
        [theme.breakpoints.up('xxxxl')]: {
            height: 70
        },
        [theme.breakpoints.up('xxxxxl')]: {
            height: 90
        },
    },
    '.value': {
        fontSize: 30,
        fontWeight: "bold"
    },
    '.card-header': {
        display: "flex",
        height: 30,
        justifyContent: "space-between",
        alignItems: "center",
        [theme.breakpoints.up('xl')]: {
            height: 40
        },
    },
    '.section-cards1': {
        boxSizing: "border-box",
        background: "white",
        borderRadius: 15,
        width: "100%",
        display: "flex",
        columnGap: 15,
        padding: 20,
        justifyContent: "center",
        [theme.breakpoints.down('lg')]: {
            flexDirection: "column",
            alignItems: "center",
            rowGap: 15
        },
    },
    '.section-cards2': {
        display: "flex",
        columnGap: 15,
        flexGrow: 1,
        [theme.breakpoints.down('xl')]: {
            flexDirection: "column",
            alignItems: "center",
            rowGap: 15
        },
        [theme.breakpoints.up('xxxxl')]: {
            flexGrow: 0

        },
    },
    '.card': {
        // width: 280,
        flexGrow: 1,
        height: "100%",
        border: `1px solid ${thirdly2}`,
        background: thirdly4,
        borderRadius: 14,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        padding: "10px 10px",

    }
}));

const BarStyles = muiStyled(Box)(({ type, theme, $systemUI }) => ({
    width: "100%",
    '.bar-chart-labels': {
        display: "flex"
    },
    '.line-divider': {
        background: thirdly2,
        width: 1,
        height: 25
    },
    '.dot': {
        width: 8,
        height: 8,
        borderRadius: 30
    },
    '.bar-chart-years': {
        display: "flex",
        alignItems: "center",
        columnGap: 12
    },
    '.bar-chart-years-title': {
        color: "#26445A80",
        fontWeight: "bold"
    },
    '.bar-chart-detail': {
        display: "flex",
        flexDirection: "column",
        columnGap: 8,
        rowGap: 5
    },
    '.bar-chart': {
        width: "100%",
        minHeight: 200,
        fontWeight: "bold",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    '.bar-chart-details': {
        display: "flex",
        justifyContent: "space-between",
        columnGap: 10,
        width: "100%"
    },
    '.wrap-bar-chart': {
        display: "flex",
        flexDirection: "column",
        rowGap: 15,
        width: "100%"
    },
}));

const Dashboard = styled.div`
padding:15px;
display: flex;
flex-direction: column;
row-gap: 15px;
width:95%;
`

const WrapHeader = styled.div`
display: flex;
column-gap: 10px;
justify-content:space-between;
`

const WrapContent = styled.div`
display: flex;
column-gap:20px;
`

const WrapTitle = styled.div`
width:140px;
`

const Title = styled.div`
color:${black};
// font-size:20px;
font-size:0.900rem;
`

const WrapVideo = styled.div`
display: flex;
`

const WrapCartoon = styled(WrapImg)`
position: relative;
right: 112px;
`

const IOSSwitch = muiStyled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: thirdly,
                opacity: 1,
                border: 0,
                ...theme.applyStyles('dark', {
                    backgroundColor: thirdly,
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
            ...theme.applyStyles('dark', {
                color: theme.palette.grey[600],
            }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            ...theme.applyStyles('dark', {
                opacity: 0.3,
            }),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E6F0FE',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        ...theme.applyStyles('dark', {
            backgroundColor: '#E6F0FE',
        }),
    },
}));

// compact — גרסה מוקטנת לפאנל הצד של עמוד הפתיחה במצגת (חייבת להיכנס בלי גלילה,
// כמו שאר פאנלי הצד); ברירת המחדל (ללא compact) היא הכרטיס המקורי בדשבורד הרגיל, ללא שינוי
export const RatingBarChartStyles = muiStyled(Box)(({ compact }) => ({
    display: 'flex',
    flexDirection: 'column',
    rowGap: compact ? 8 : 12,
    height: '100%',
    justifyContent: 'center',
    '.bar-wrap': {
        height: compact ? 130 : 220,
        position: 'relative'
    },
    '.no-results': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        minHeight: 150,
        color: '#94a3b8',
        fontSize: 16
    },
    '.quick-summary': {
        background: '#F8FAFC',
        border: '1px solid #E2E8F0',
        borderRadius: 10,
        padding: compact ? '8px 12px' : '10px 14px',
        display: 'flex',
        flexDirection: 'column',
        rowGap: compact ? 4 : 6
    },
    '.summary-title': {
        fontWeight: 700,
        fontSize: compact ? 13 : 15,
        marginBottom: 2
    },
    '.summary-body': {
        display: 'flex',
        flexDirection: 'column',
        rowGap: 3
    },
    '.summary-line': {
        fontSize: compact ? 12.5 : 14,
        lineHeight: compact ? 1.45 : 1.6
    },
    '.warning-line': {
        display: 'flex',
        alignItems: 'flex-start',
        columnGap: 8,
        background: '#FFFBEB',
        border: '1px solid #FCD34D',
        borderRadius: 10,
        padding: compact ? '8px 12px' : '10px 14px',
        fontSize: compact ? 12.5 : 14,
        color: '#92400E',
        lineHeight: compact ? 1.35 : 1.4,
        marginTop: compact ? 2 : 4,
        '.warning-icon': {
            fontSize: 16,
            color: '#B45309',
            flexShrink: 0
        }
    }
}))

export { CartoonStyles, BarStyles, IOSSwitch, WrapCartoon, WrapVideo, Dashboard, DoughnutChartStyles, StudentDashboardStyles, DashboardStyles, WrapHeader, WrapContent, WrapTitle, Title, CardStyles }